export const approvalStatusMapping = {
  a: 'APPROVED',
  p: 'PENDING',
  r: 'REJECTED',
};
